// since keywords were removed from signup,
// this component is not currently used and
// has out of date code

import { Inject, Component, Input, Output, EventEmitter, ElementRef, OnInit } from '@angular/core'
import { Keyword, Account, Customer, TimeZone } from '../../types'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { ValidationService } from '../../services/validation-service'
import remove from 'lodash-es/remove'
import moment from 'moment'
import 'moment-timezone'
import sweetAlert from '../../bmAlert'
import get from 'lodash-es/get'
import { graphqlPatch, graphqlDelete } from '../../graphql/mutation-helper'
import {
  CreateKeywordInput,
  UpdateKeywordInput,
  DeleteKeywordInput,
  KeywordExpandedInput,
  KeywordEditingInput,
} from '../../graphql/inputs/keyword.inputs'
import {
  CreateDocumentInput,
  RemoveDocumentInput,
} from '../../graphql/inputs/document.inputs'

@Component({
  selector: 'keyword-panel',
  template: (`
    <div class="panel-group">
      <div class="panel panel-default">
        <div class="panel-heading">
          <h5 class="panel-title">
            <span *ngIf="!keyword; else elseHeading">Add a post topic:</span>
            <ng-template #elseHeading>
              <div class="cursor-pointer row">
                <div (click)="onToggleExpanded()" class="col-lg-9 col-8 d-flex align-items-start">
                  <span class="fas" [class.fa-chevron-down]="keyword.expanded" [class.fa-chevron-right]="!keyword.expanded"></span>
                  <ng-template #deadlinePopoverBody>
                    <div>
                      Due: {{ timeInTz(keyword.deadline, keyword.timeZone)}}
                      <div *ngIf="keyword && keyword.claimedBy && claimedWriter">
                        <span class="text-green">
                          <i class="fas fa-check"></i>
                          Claimed
                        </span>
                        by
                        <i>{{keyword.claimedWriter.displayName}}</i>
                      </div>
                    </div>
                  </ng-template>

                  <span *ngIf="keyword?.deadline"
                        class="cursor-default far fa-clock tiny-left-buffer"
                        [class.text-light-gray]="!keyword?.claimedBy"
                        [class.text-danger]="deadlinePastDue(keyword.deadline)"
                        [class.text-green]="keyword.claimedBy"
                        popoverTitle="{{keyword?.claimedBy ? 'Deadline Claimed' : (deadlinePastDue(keyword.deadline) ? 'Deadline Past Due' : 'Deadline Set')}}"
                        [popover]="deadlinePopoverBody"
                        triggers="mouseenter:mouseleave"
                        placement="top"
                        container="body"></span>
                  <span class="tiny-left-buffer">{{keyword.phrase}}</span>
                </div>
                <div class="col-lg-3 col-4 text-right" dropdown>
                  <ng-template [ngIf]="!newCustomer">
                    <a class="fas fa-exchange-alt" title="move" dropdownToggle></a>
                    <ul class="dropdown-menu" *dropdownMenu>
                      <li *ngIf="notInState('active')"><a (click)="changeStateTo('active')">ongoing</a></li>
                      <li *ngIf="notInState('timely')"><a (click)="changeStateTo('timely')">one-time</a></li>
                      <li *ngIf="notInState('paused')"><a (click)="changeStateTo('paused')">paused</a></li>
                    </ul>
                  </ng-template>
                  <a *ngIf="notInState('deleted')" class="far fa-trash-alt-o" title="delete" (click)="deleteKeyword()"></a>
                  <span class="cursor-default fa-stack stack-shrink" *ngIf="!newCustomer">
                    <i class="far fa-file fa-stack-2x"></i>
                    <strong class="fa-stack-1x fa-stack-text file-text">
                      {{keyword?.postedCount}}
                    </strong>
                  </span>
                </div>
              </div>
            </ng-template>
          </h5>
        </div>



        <div *ngIf="open || keyword.expanded" class="panel-collapse">
          <div class="panel-body">

            <!-- =============================== -->
            <!-- ======    DISPLAYING      ===== -->
            <!-- =============================== -->
            <div *ngIf="keyword && !keyword.editing; else keywordEditingBlock">

              <!-- Topic -->
              <label>Title:</label>
              <p>{{keyword.phrase}}</p>

              <!-- Description -->
              <ng-template [ngIf]="keyword?.description">
                <label class="top-buffer">Description:</label>
                <div class="desc" style="min-height: 40px">{{keyword.description}}</div>
              </ng-template>

              <!-- buttons -->
              <a class="hot-orange-button" (click)="onToggleEditing(true)">Edit</a>
            </div>


            <!-- =============================== -->
            <!-- ======      EDITING       ===== -->
            <!-- =============================== -->
            <ng-template #keywordEditingBlock>
              <form [formGroup]="form" (ngSubmit)="onSubmit()">
                <div class="form-group">

                  <!-- Topic -->
                  <div class="small-bottom-buffer">
                    <label>Title:<sup class="text-danger">*</sup></label>
                    <input id="{{!keyword ? 'new-phrase' : ''}}" class="form-control" formControlName="phrase" type="text" [placeholder]="placeholders.phrase" required>
                    <div [hidden]="form.controls.phrase.valid || form.controls.phrase.pristine" class="alert alert-danger">
                      A title is required
                    </div>
                  </div>

                  <!-- Description -->
                  <div class="description bottom-buffer">
                    <label>
                      Description:
                      <ng-template #descriptionInfo>
                        <div class="text-left">
                          Include a description of what you'd like for this post, and any instructions to writers. This could include:
                          <ul>
                            <li>Links to reference posts</li>
                            <li>The point of view you'd like a writer to take</li>
                          </ul>
                        </div>
                      </ng-template>
                      <i
                        class="tiny-left-buffer text-blue fas fa-question-circle"
                        [popover]="descriptionInfo"
                        popoverTitle="Topic Description"
                        triggers="mouseenter:mouseleave"
                        placement="top"
                        container="body"></i>
                    </label>

                    <textarea class="form-control" formControlName="description" rows="5" style="resize:vertical" [placeholder]="placeholders.description"></textarea>
                  </div>

                  <hr *ngIf="newCustomer">
                </div>

                <!-- buttons -->
                <button type="submit" class="hot-orange-button" [disabled]="!(form.controls.deadline.pristine || form.valid)">{{keyword ? 'Update Request' : 'Add Request'}}</button>
                <button type="button" class="btn btn-default" [class.small-left-buffer]="!keyword" (click)="cancelEdits()" *ngIf="!newCustomer">Cancel</button>

              </form>
            </ng-template>

            <!-- NOT DISPLAYED DURING SIGNUP -->
            <ng-template [ngIf]="!newCustomer">

              <!--  Upload PDF -->
              <hr>
              <div *ngIf="keyword; else uploadPdfNewKeyword">
                <div class="tiny-bottom-buffer" *ngIf="keyword?.documents?.length > 0">Files</div>
                <div *ngFor="let doc of keyword?.documents" class="clearfix">
                  <a href="{{ doc.fileUrl }}" target="_blank">{{ doc.name }}</a>
                  <i class="fas fa-spinner text-muted float-right" *ngIf="doc.pending"></i>
                  <a class="float-right cursor-pointer" (click)="onRemoveDoc(doc.id)" *ngIf="!doc.pending">
                    <span class="fas fa-times text-danger"></span>
                  </a>
                </div>
                <button type="button" class="btn btn-default" [class.small-top-buffer]="keyword?.documents?.length > 0" (click)="uploadClicked($event, 'upload_pdf_update_keyword')">
                  <i class="fas fa-upload"></i>
                  Upload PDF
                </button>
                <input id="upload_pdf_update_keyword" value="Upload PDF" type="file" accept=".pdf" (change)="fileSelected($event)" style="display:none;">
              </div>

              <ng-template #uploadPdfNewKeyword>
                <div class="tiny-bottom-buffer" *ngIf="tempUploads.length > 0">Files</div>
                <div *ngFor="let f of tempUploads" class="clearfix">
                  <span>{{ f.name }}</span>
                  <a class="float-right" href="" (click)="removeTempUpload(f.name)">
                    <span class="fas fa-times text-danger"></span>
                  </a>
                </div>
                <button *ngIf="!newCustomer" type="button" class="btn btn-default" [class.small-top-buffer]="tempUploads.length > 0" (click)="uploadClicked($event, 'upload_pdf_new_keyword')">
                  <i class="fas fa-upload"></i>
                  Upload PDF
                </button>
                <input id="upload_pdf_new_keyword" value="Upload PDF" type="file" accept=".pdf" (change)="fileSelected($event)" style="display:none;">
              </ng-template>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  `),
})
export class KeywordPanel implements OnInit {
  @Input() keyword: Keyword;
  @Input() account: Account;
  @Input() customer: Customer;
  @Input() open: boolean = false;
  @Input() newState: string = 'active';
  @Input() newCustomer: boolean = false;
  @Input() timeZones: TimeZone[];
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output() create: EventEmitter<CreateKeywordInput> = new EventEmitter<CreateKeywordInput>();
  @Output() update: EventEmitter<UpdateKeywordInput> = new EventEmitter<UpdateKeywordInput>();
  @Output() delete: EventEmitter<DeleteKeywordInput> = new EventEmitter<DeleteKeywordInput>();
  @Output() uploadDoc: EventEmitter<CreateDocumentInput> = new EventEmitter<CreateDocumentInput>();
  @Output() removeDoc: EventEmitter<RemoveDocumentInput> = new EventEmitter<RemoveDocumentInput>();
  @Output() toggleExpanded: EventEmitter<KeywordExpandedInput> = new EventEmitter<KeywordExpandedInput>();
  @Output() toggleEditing: EventEmitter<KeywordEditingInput> = new EventEmitter<KeywordEditingInput>();

  public dirty: boolean = false;
  form: FormGroup;
  tempUploads: File[] = [];
  private priorities: string[] = ['Low', 'Medium', 'High'];
  private selectedPriorityValue: number;
  private selectedPriority: string;
  showSeoOptions: boolean = false;
  fb: FormBuilder;

  constructor(
    @Inject(ElementRef) private ElementRef: ElementRef,
    fb: FormBuilder) {
      this.fb = fb
    }

  ngOnInit(): void {
    this.resetForm()
    this.selectedPriorityValue = 1
    this.selectedPriority = 'Medium'
    if (this.keyword) {
      this.selectedPriorityValue = this.keyword.priority
      this.selectedPriority = this.priorities[this.keyword.priority]

      if (this.keyword.editing && this.hasSeoAdvancedOptions()) this.showSeoOptions = true
    }
  }

  updatePostLimit(postLimit: number): void {
    this.form.patchValue({ postLimit })
  }

  ngAfterViewInit(): void {
    let newPhrase = this.ElementRef.nativeElement.querySelector('#new-phrase')
    if (newPhrase) newPhrase.focus()
  }

  cancelEdits(cb?: Function) {
    if (!this.dirty) {
      if (this.keyword) {
        this.onToggleEditing(false)
      } else {
        this.close.emit(true)
      }
      if (cb) cb()
    }

    // If editing previous keyword, check with user before canceling
    else if (this.dirty) {
      sweetAlert.confirm({text: "Any unsaved changes will be lost."}).then(confirm => {
        if (confirm) {
          if (this.keyword) {
            this.onToggleEditing(false)
          } else {
            this.close.emit(true)
          }
          this.resetForm()
          if (cb) cb()
        }
      })
    }
  }

  resetForm(): void {
    this.dirty = false
    this.form = this.fb.group({
      phrase:           [get(this.keyword, 'phrase', ''), Validators.required],
      description:      [get(this.keyword, 'description', '')],
      priority:         [get(this.keyword, 'priority', 1)],
      focusKeywords:    [get(this.keyword, 'focusKeywords', '')],
      link:             [get(this.keyword, 'link', ''), ValidationService.urlValidator],
      linkText:         [get(this.keyword, 'linkText', '')],
      externalLinks:    [get(this.keyword, 'externalLinks', null)],
      seoNotes:         [get(this.keyword, 'seoNotes', '')],
      deadline:         [(this.keyword && this.keyword.deadline ? moment(this.keyword.deadline).toDate() : ''), null],
      timeZone:         [get(this.keyword, 'timeZone', this.guessTimeZone()), null],
      postLimit:        [get(this.keyword, 'postLimit', 1)]
    })
    this.form.valueChanges.subscribe(() => {
      this.dirty = true
    })
  }

  notInState(state: string): boolean {
    return this.keyword.state !== state
  }

  onToggleExpanded(): void {
    this.toggleExpanded.emit({ id: this.keyword.id, expanded: !this.keyword.expanded })
  }

  onToggleEditing(editing: boolean = !this.keyword.editing): void {
    this.toggleEditing.emit({ id: this.keyword.id, editing })
  }

  // STORE & SERVER UPDATES
  onSubmit(): void {
    if (this.form.valid && !this.linkTextInvalid(this.form)) {
      let deadline = this.form.controls.deadline.value
      if (deadline) {
        // set time zone, truncate minutes & second, and set hour (after tz)
        const hour = moment(deadline).hour()
        deadline = moment(deadline).tz(this.form.get('timeZone').value).set({ hour, minute: 0, second: 0 }).format()
        this.form.patchValue({ priority: 1 }) // deadlines can't have priority'
      }

      // Creating a new keyword
      if (!this.keyword) {
        const newForm = this.form.value
        newForm.state = 'active'
        newForm.priority = this.selectedPriorityValue
        newForm.deadline = deadline
        const createObj = {
          customerId: this.customer.id,
          body: graphqlPatch(newForm),
          documents: [],
          files: this.tempUploads
        }
        this.create.emit(createObj)
      }

      // Updating existing keyword
      else {
        const formValue = this.form.value
        if (!formValue.deadline) formValue.priority = this.selectedPriorityValue
        formValue.state = this.keyword.state
        formValue.priority = +formValue.priority
        formValue.deadline = deadline

        const updateObj = {
          customerId: this.keyword.customerId,
          id: this.keyword.id,
          updates: formValue,
        }

        // Warn user if removing deadline that has been claimed
        if (!deadline && this.keyword.deadline && this.keyword.writerId) {
          sweetAlert.confirm({
            title: "Remove Deadline From Writer?",
            text: "A writer has already claimed your deadline. Are you sure you want to remove it?",
          }).then(confirm => {
            if (confirm) {
              this.update.emit(updateObj)
            }
          })
        } else {
          this.update.emit(updateObj)
        }
      }

    }
  }

  changeStateTo(state: string): void {
    const updateObj = {
      customerId: this.keyword.customerId,
      id: this.keyword.id,
      updates: { state } as Partial<Keyword>
    }

    if (this.keyword.deadline) {
      sweetAlert.confirm({
        title: 'Remove Deadline?',
        text: "Are you sure? Moving this topic will remove it's deadline.",
      }).then(confirm => {
        if (confirm) {
          updateObj.updates = Object.assign({}, updateObj.updates, {deadline: null})
          this.update.emit(updateObj)
        }
      })
    } else {
      this.update.emit(updateObj)
    }
  }

  deleteKeyword(): void {
    if (this.keyword.deadline) {
      sweetAlert.confirm({
        title: 'Remove Deadline?',
        text: "Are you sure? Deleting this topic will remove it's deadline.",
      }).then(confirm => {
        if (confirm) {
          const updateObj = {
            customerId: this.keyword.customerId,
            id: this.keyword.id,
            updates: {deadline: null} as Partial<Keyword>
          }
          this.update.emit(updateObj)
          this.delete.emit({
            customerId: this.keyword.customerId,
            id: this.keyword.id
          })
        }
      })
    } else {
      sweetAlert.confirm({text: "Are you sure you want to delete this topic?"}).then(confirm => {
        if (confirm) {
          this.delete.emit({
            customerId: this.keyword.customerId,
            id: this.keyword.id
          })
        }
      })
    }
  }

  fileSelected(e: Event): void {
    const files = (<FileList>(<HTMLInputElement>e.target).files)
    const file = files ? files[0] : null
    if (file) {
      const keywordAndFile: CreateDocumentInput = {
        keyword: this.keyword,
        file: file
      }
      this.keyword ? this.uploadDoc.emit(keywordAndFile) : this.addTempUpload(file)
    }
  }

  uploadClicked(event: Event, id: string): void {
    const uploader = this.ElementRef.nativeElement.querySelector(`#${id}`)
    if (uploader) uploader.click()
  }

  onRemoveDoc(id: number): void {
    sweetAlert.confirm({text: "Are you sure you want to delete this file?"}).then(confirm => {
      if (confirm) {
        this.removeDoc.emit({customerId: this.keyword.customerId, keyword: this.keyword, id})
      }
    })
  }

  addTempUpload(f: File): void {
    this.tempUploads.push(f)
  }

  removeTempUpload(fileName: string) {
    remove(this.tempUploads, (f) => f.name === fileName)
    return false
  }

  prioritySelected(event: Event): void {
    const select = <HTMLSelectElement>event.target
    this.selectedPriorityValue = Number.parseInt(select.value)
    this.selectedPriority = this.priorities[this.selectedPriorityValue]
  }

  formatted(dateTime: string): string {
    return moment(dateTime).calendar(null, {
      sameDay: 'h:mm A',
      nextDay: '[Tomorrow]',
      nextWeek: 'dddd',
      sameElse: 'DD/MM/YYYY'
    })
  }

  phrasing(dateTime: string): string {
    if (moment(dateTime).isAfter(moment().add('years', 1))) {
      return `their submission is reviewed`
    } else {
      return this.formatted(dateTime)
    }
  }

  linkTextInvalid(form): boolean {
    return (!form.controls.link.value || !form.controls.link.valid) && (form.controls.linkText.value)
  }

  minDeadlineDate(): Date {
    return moment().add(73, 'hours').toDate()
  }

  maxDeadlineDate(): Date {
    return moment(this.minDeadlineDate()).add(2, 'months').toDate()
  }

  placeholders: object = {
    deadline: 'select a date',
    phrase: '13 Top Superfoods for Babies',
    description: 'This post should compile 13 superfoods for babies and toddlers, giving a short blurb on each one and including why each is a superfood - its nutrient information. Please start the post with a short introduction to superfoods and the concept of a balance diet for young children. Thanks!',
    focusKeywords: 'superfoods for babies, superfoods',
    link: 'mysite.com/cooking-for-parents-course',
    linkText: 'our cooking course for parents',
    seoNotes: 'Please find a good spot to link to our cooking course for parents. Thanks.'
  };

  hasSeoAdvancedOptions(): boolean {
    return this.keyword && !!(
      this.keyword.focusKeywords ||
      this.keyword.link ||
      this.keyword.linkText ||
      this.keyword.externalLinks ||
      this.keyword.seoNotes)
  }

  guessTimeZone(): string {
    const tzId = moment.tz.guess()
    return tzId ? tzId : 'America/Denver'
  }

  // z: either MST, +11, +0530 depending on what's available
  timeZoneFormat(timeZoneId: string): string {
    return timeZoneId ? moment.tz(timeZoneId).format('z') : ''
  }

  timeInTz(t: Date | moment.Moment | string, tz: string): string {
    return moment.tz(t, tz).format('ddd, MMM Do, YYYY, hA z')
  }

  deadlinePastDue(deadline: Date): boolean {
    const now = moment()
    return deadline && moment(deadline).isBefore(now)
    // TODO (after graphql) check if keyword has post submitted before deadline
  }

  deadlineFeature(account: Account): boolean {
    const features = account && account.enabledFeatures || []
    return features.includes('deadlines') || features.includes('direct_assignments')
  }
}
